import TopBlock from './TopBlock';
import EntireFeed from './EntireFeed';

const FreeCourse = () => (
  <>
    <TopBlock />
    <EntireFeed />
  </>
);

export default FreeCourse;
